import React from "react";
import {
  CircularProgress,
  Box,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";

const CircularProgressWithLabel = ({
  value,
  size = 60,
  thickness = 5,
  color = "green",
  textColor = "white",
  right = "45px",
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        display: "inline-flex",
        right: isSmallScreen ? 0 : right,
      }}
    >
      <CircularProgress
        variant="determinate"
        value={value}
        size={isSmallScreen ? 35 : size}
        thickness={thickness}
        sx={{ color: color }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="body1"
          component="div"
          sx={{
            color: textColor,
            fontWeight: "bold",
            fontSize: "clamp(0.6rem, 2vw, 0.8rem)",
          }}
        >
          {`${value}%`}
        </Typography>
      </Box>
    </Box>
  );
};

export default CircularProgressWithLabel;
